var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.vilocalType
    ? _c("div", { staticClass: "vilocal-order-tag" }, [
        _vm.vilocalType === 1 ? _c("div", [_vm._v("Free trial")]) : _vm._e(),
        _vm._v(" "),
        _vm.vilocalType === 2 ? _c("div", [_vm._v("Free returns")]) : _vm._e(),
        _vm._v(" "),
        _vm.vilocalType === 3
          ? _c("div", [_vm._v("Free trial with Free returns")])
          : _vm._e(),
        _vm._v(" "),
        _vm.vilocalType === 4
          ? _c("div", [
              _vm._v(
                _vm._s(
                  _vm.skuDetailArr && _vm.skuDetailArr.length > 0
                    ? (
                        Number(1 - _vm.skuDetailArr[0].discountTrialRate) * 100
                      ).toFixed(0)
                    : 0
                ) + "% off trial"
              )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6040f6f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6040f6f1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/vilocal-order-tag.vue
// module id = null
// module chunks = 